import { UserProfile } from '@admin-shared/models/user-profile';
import { Observable } from 'rxjs';
import { AuthAccount } from '../../models/auth-account';
import { Charge } from '../../models/charge';
import { AccessToken } from '../../types/access-token';
import { UserCredentials } from '../../types/user-credentials';
import { StorageParameters } from '../storage.service';
import { ApiBase } from './api.base';

export class UsersApi extends ApiBase {
  model = 'users';

  login(credentials: UserCredentials) {
    return this.http.post<AccessToken>(this.buildUrl('login'), credentials);
  }

  authenticated() {
    return this.http.get<AuthAccount>(this.buildUrl('authenticated'), {
      headers: this.setHeaders({
        Authorization: this.getStorage().getItem(
          StorageParameters.AccessTokenId
        ),
      }),
    });
  }

  purchase(
    id: string,
    itemId: string,
    cardId: string,
    auctionPurchaseId?: string
  ): Observable<Charge & { itemId?: string }> {
    return this.http.post<Charge>(
      this.buildUrl(id, 'purchase'),
      {
        itemId,
        cardId,
        auctionPurchaseId,
      },
      {
        headers: this.setHeaders({
          Authorization: this.getStorage().getItem(
            StorageParameters.AccessTokenId
          ),
        }),
      }
    );
  }

  addCard(
    id: string,
    cardInfo: {
      exp_month: string;
      exp_year: string;
      number: string;
      cvv: string;
      zipCode: string;
      address1: string;
      currency?: string;
    }
  ) {
    return this.http.post<{ cardId: string }>(
      this.buildUrl(id, 'add-card'),
      cardInfo,
      {
        headers: this.setHeaders({
          Authorization: this.getStorage().getItem(
            StorageParameters.AccessTokenId
          ),
        }),
      }
    );
  }

  resetPassword(email: string) {
    return this.http.post<{ result: string; message: string }>(
      this.buildUrl('reset-password'),
      { email }
    );
  }

  checkResetId(resetId: string) {
    return this.http.post<{ result: string; message: string }>(
      this.buildUrl('check-reset-id'),
      { resetId }
    );
  }

  passwordConfirmation(newPassword: string, resetId: string) {
    return this.http.post<{ result: string; message: string }>(
      this.buildUrl('password-confirmation'),
      { newPassword, resetId }
    );
  }

  usersByEmail(email: string) {
    return this.http.get<UserProfile[]>(this.buildUrl('byEmail', email), {
      headers: this.setHeaders({
        Authorization: this.getStorage().getItem(
          StorageParameters.AccessTokenId
        ),
      }),
    });
  }
}
